import React from 'react';
import { SimpleSelect, SearchableSelect } from 'mintel-react-ui';

import FieldErrors from './FieldErrors';

export type SelectWrapperProps = {
  name: string;
  options: SelectOptions;
  selected: string[] | number[];
  onSelect: (newSelected: string[]) => void;
  multiple?: boolean;
  searchable?: boolean;
  label: string;
  id?: string;
  required?: boolean;
  errors?: string[];
};

export const SelectWrapper = ({
  name,
  options,
  selected,
  multiple = false,
  searchable = false,
  required = false,
  label,
  id,
  errors,
  ...selectProps
}: SelectWrapperProps): JSX.Element => {
  const selectedStrs = selected.map((v: string | number) => v.toString());
  const optionStrs = options.map(({ label: optLabel, value }) => ({
    label: optLabel,
    value: value.toString(),
  }));
  const commonProps = {
    selected: selectedStrs,
    options: optionStrs,
    multiple,
    label,
    required,
    ariaDescribedBy: undefined as string | undefined,
    ...selectProps,
  };
  let errorId;
  if (errors && errors.length > 0) {
    errorId = `${id}-error`;
    commonProps.ariaDescribedBy = errorId;
  }

  return (
    <div>
      <select
        hidden
        name={name}
        value={selectedStrs}
        multiple
        onChange={() => {}}
        id={id}
        data-testid="formSelect"
      >
        {options.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div data-testid={`${name}Select`}>
        {searchable ? (
          <SearchableSelect {...commonProps} />
        ) : (
          <SimpleSelect {...commonProps} />
        )}
        {errors && errors.length > 0 && (
          <FieldErrors errors={errors} id={errorId} />
        )}
      </div>
    </div>
  );
};

export default SelectWrapper;
